import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../numberUtils';
import './DisplayLineItem.scss';

function DisplayLineItem({
  id,
  hasDuration,
  viewDocumentUrl,
  documentName,
  date,
  optional_id,
  description,
  hours,
  minutes,
  total,
  feedback,
  showFeedback,
  index,
}) {
  return (
    <div
      id={`line-item-${id}`}
      className={`line-item display-line-item-full-width ${index % 2 === 1 ? 'even-row' : null}`}
    >
      <div className={`display-line-item g-row--always ${showFeedback && feedback ? 'with-feedback' : ''}`}>
        {showFeedback && feedback
        && <i className="edits-requested-indicator fa fa-circle" />}
        <div className={`date ${showFeedback && feedback ? 'with-feedback' : ''}`}>{date}</div>
        <div className="optional-id">{optional_id}</div>
        <div className="description">
          {description}
        </div>
        {hasDuration
        && (
        <div className="hours-and-minutes">
          {hours}
          {' '}
          h
          {' '}
          {minutes}
          {' '}
          min
        </div>
        )}

        <div className="total">
          {formatCurrency(total)}
        </div>
        {!hasDuration
        && (
        <div className="file">
          {documentName && <a href={viewDocumentUrl}>{documentName}</a>}
        </div>
        )}
      </div>
      {showFeedback && feedback
      && (
      <div className="line-item-feedback body-text-2">
        <div className="medium-weight pb-8">Comments</div>
        <div>{feedback}</div>
      </div>
      )}
    </div>
  );
}

DisplayLineItem.propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  optional_id: PropTypes.string.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  hasDuration: PropTypes.bool,
  viewDocumentUrl: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  documentName: PropTypes.string,
  feedback: PropTypes.string,
  showFeedback: PropTypes.bool,
  index: PropTypes.number.isRequired,
};

DisplayLineItem.defaultProps = {
  hasDuration: false,
  documentName: null,
  feedback: null,
  showFeedback: false,
};

export default DisplayLineItem;
